module.exports = __webpack_public_path__ + "static/media/photostack.04891f73.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/photostack.PNG
// module id = 91
// module chunks = 0